module.exports = __webpack_public_path__ + "img/05_Betonsarkophag_iPad_P.ff541277.jpg";